<template>
    <div>
        <ul class="nav nav-pills mb-4" role="tablist">
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'forbidden' ? 'active' : '']"
                   @click="setTab('forbidden')"
                   href="#"
                   role="tab"
                   style="border: 2px solid #0056b3; border-radius: 5px;"
                >
                    <span v-text="$t('label.wallet_settlement_blacklist.forbidden_keywords_title')"></span>
                </a>
            </li>
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'sheba' ? 'active' : '']"
                   @click="setTab('sheba')"
                   href="#"
                   role="tab"
                   style="border: 2px solid #0056b3; border-radius: 5px;"
                >
                    <span v-text="$t('label.wallet_settlement_blacklist.forbidden_sheba_title')"></span>
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <forbidden-keywords-tab v-if="active_tab === 'forbidden'" />
            <sheba-keywords-tab v-if="active_tab === 'sheba'" />
        </div>
    </div>
</template>

<script>
import ForbiddenKeywordsTab from './ForbiddenKeywordsTab.vue'
import ShebaKeywordsTab from './ShebaKeywordsTab.vue'
import mainContent from '@/components/main-content.vue'

export default {
    components: {
        'forbidden-keywords-tab': ForbiddenKeywordsTab,
        'sheba-keywords-tab': ShebaKeywordsTab,
        'main-content': mainContent,
    },
    data() {
        return {
            active_tab: 'forbidden'
        }
    },
    methods: {
        setTab(tab) {
            this.active_tab = tab
        }
    }
}
</script>

<style scoped>
.nav-pills .nav-link {
    color: #6c757d;
    border-radius: 0.375rem;
    margin-right: 0.5rem;
    padding: 0.75rem 1.25rem;
    background-color: transparent;
    border: 1px solid transparent;
    transition: all 0.3s ease;
}

.nav-pills .nav-link:hover {
    color: #495057;
    background-color: #f8f9fa;
    border-color: #dee2e6;
}

.nav-pills .nav-link.active {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.nav-pills .nav-link.active:hover {
    background-color: #0056b3;
    border-color: #004085;
}

.tab-content {
    margin-top: 1rem;
}

.mb-4 {
    margin-bottom: 1.5rem !important;
}

@media (max-width: 768px) {
    .nav-pills {
        flex-direction: column;
    }
    
    .nav-pills .nav-link {
        margin-right: 0;
        margin-bottom: 0.5rem;
        text-align: center;
    }
}
</style>